module.exports = __webpack_public_path__ + "img/mail.7289f3fa.svg";